import React from 'react';

const STATUS_CONFIG = {
  PLANIFICACION: { label: 'PLANIFICACIÓN', bgColor: '#fee2e2', textColor: '#dc2626', dotColor: '#dc2626' },
  EN_CURSO: { label: 'EN CURSO', bgColor: '#dbeafe', textColor: '#2563eb', dotColor: '#2563eb' },
  FINALIZADA: { label: 'FINALIZADA', bgColor: '#dcfce7', textColor: '#16a34a', dotColor: '#16a34a' },
  BLOQUEADA: { label: 'BLOQUEADA', bgColor: '#fef3c7', textColor: '#d97706', dotColor: '#d97706' },
};

/**
 * StatusTag - Componente para mostrar el estado de una tarea
 * @param {string} statusKey - Clave del estado (PLANIFICACION, EN_CURSO, FINALIZADA, BLOQUEADA)
 * @param {boolean} showDot - Mostrar el punto de color (por defecto true)
 */
const StatusTag = ({ statusKey = 'EN_CURSO', showDot = true }) => {
  const config = STATUS_CONFIG[statusKey] || STATUS_CONFIG.EN_CURSO;

  return (
    <span
      style={{
        backgroundColor: config.bgColor,
        color: config.textColor,
      }}
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-medium whitespace-nowrap"
    >
      {showDot && (
        <span
          style={{ backgroundColor: config.dotColor }}
          className="w-1.5 h-1.5 rounded-full"
        />
      )}
      {config.label}
    </span>
  );
};

export default StatusTag;
